import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'

import Layout from '../components/Layout'
import EmailFormTemplate from '../components/templates/EmailFormTemplate'

const EmailForm = ({data}) => {
  const frontmatter = get(data, 'markdownRemark.frontmatter', {})
  return (
    <Layout frontmatter={frontmatter}>
      <EmailFormTemplate
        header={frontmatter.header}
        text1={frontmatter.text1}
        text2={frontmatter.text2}
        text3={frontmatter.text3}
        emailAddress={frontmatter.emailAddress}
        logo={frontmatter.logo}
        backgroundImage={frontmatter.backgroundImage}
        primaryColor={frontmatter.primaryColor}
      />
    </Layout>
  )
}

export default EmailForm

export const pageQuery = graphql`
  query EmailFormByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        templateKey
        description
        title
        header
        text1
        text2
        text3
        emailAddress
        logo
        backgroundImage
        backgroundColor
        primaryColor
        favicon
      }
    }
  }
`